import Head from 'next/head';
import parseHtml from 'html-react-parser';
import React, {useEffect} from 'react';
import {GetServerSideProps} from 'next';
import {NextPageWithPageLayoutOptions} from '../components/page-layout/types';
import {parseOptions, setBodyClass, insertIframe} from '../utils/webflow-util';

const ProtocolPage: NextPageWithPageLayoutOptions = (props: any) => {
  useEffect(() => {
    setBodyClass('tokentraxx-body');
    insertIframe();
  }, []);
  if (!props.headContent && !props.bodyContent) {
    return <></>;
  }
  return (
    <>
      <Head>{parseHtml(props.headContent, parseOptions)}</Head>
      {parseHtml(props.bodyContent, parseOptions)}
    </>
  );
};

export const getStaticProps: GetServerSideProps = async () => {
  const cheerio = await import(`cheerio`);
  const axios = (await import(`axios`)).default;

  const url = 'protocol';
  const fetchUrl = process.env.WEBFLOW_URL + url;

  // Fetch HTML
  const res: any = await axios(fetchUrl);
  const html = res.data;

  // Parse HTML with Cheerio
  const $ = cheerio.load(html);

  const bodyContent = $(`body`).html();
  const headContent = $(`head`).html();

  return {
    props: {
      bodyContent,
      headContent,
    },
  };
};

export default ProtocolPage;
